import LayerGroup from 'ol/layer/Group';
import TileLayer from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS';
import { urlWMSInundaciones, formatoPNG } from './configuracion';

const layer0037 = new TileLayer({
  title: 'Máscara 20180924',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20180924l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0037.setVisible(false);
  
const layer0036 = new TileLayer({
  title: 'Máscara 20181205',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20181205l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0036.setVisible(false);
  
const layer0035 = new TileLayer({
  title: 'Máscara 20190106',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20190106l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0035.setVisible(false);
  
const layer0034 = new TileLayer({
  title: 'Máscara 20190114',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20190114l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0034.setVisible(false);
  
const layer0033 = new TileLayer({
  title: 'Máscara 20190207',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20190207l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0033.setVisible(false);
  
const layer0032 = new TileLayer({
  title: 'Máscara 20190223',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20190223l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0032.setVisible(false);

const layer0031 = new TileLayer({
  title: 'Máscara 20190303',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20190303l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0031.setVisible(false);
  
const layer0030 = new TileLayer({
  title: 'Máscara 20190311',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20190311l7etm202_34_GRN1_inun', format: formatoPNG},
    gutter: 200,
  })
});
layer0030.setVisible(false);

const layer0029 = new TileLayer({
  title: 'Máscara 20190319',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20190319l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0029.setVisible(false);

const layer0028 = new TileLayer({
  title: 'Máscara 20190404',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20190404l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0028.setVisible(false);

const layer0027 = new TileLayer({
  title: 'Máscara 20190412',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20190412l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0027.setVisible(false);
  
const layer0026 = new TileLayer({
  title: 'Máscara 20190428',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20190428l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0026.setVisible(false);
  
const layer0025 = new TileLayer({
  title: 'Máscara 20190514',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20190514l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0025.setVisible(false);
  
const layer0024 = new TileLayer({
  title: 'Máscara 20190522',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20190522l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0024.setVisible(false);
  
const layer0023 = new TileLayer({
  title: 'Máscara 20190530',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20190530l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0023.setVisible(false);
  
const layer0022 = new TileLayer({
  title: 'Máscara 20190607',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20190607l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0022.setVisible(false);
  
const layer0021 = new TileLayer({
  title: 'Máscara 20190615',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20190615l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0021.setVisible(false);
 
const layer0020 = new TileLayer({
  title: 'Máscara 20190709',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20190709l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0020.setVisible(false);

const layer0019 = new TileLayer({
  title: 'Máscara 20190802',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20190802l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0019.setVisible(false);

const layer0018 = new TileLayer({
  title: 'Máscara 20190810',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20190810l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0018.setVisible(false);

const layer0017 = new TileLayer({
  title: 'Máscara 20190818',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20190818l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0017.setVisible(false);

export const grupoCapa01_3 = new LayerGroup({
  title: 'Ciclo Hidrológico 2018-2019',
  fold: 'close',
  layers: [layer0017, layer0018, layer0019, layer0020, layer0021, layer0022, layer0023, layer0024, layer0025, layer0026, layer0027, layer0028, layer0029, layer0030, layer0031, layer0032, layer0033, layer0034, layer0035, layer0036, layer0037]
});